import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center align-center py-8"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "font-weight-medium" }
const _hoisted_6 = { class: "d-flex align-center mb-4" }
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "text-h4 mr-3" }
const _hoisted_9 = { class: "d-flex flex-column align-start" }
const _hoisted_10 = { class: "text-body-2 font-weight-medium" }
const _hoisted_11 = { class: "d-flex justify-end" }

import { ref, onMounted, computed } from 'vue'
import AdminLayout from './components/AdminLayout.vue'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast/src'
import data from 'emoji-mart-vue-fast/data/all.json'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import { useRouter } from 'vue-router'
import { useAuthStore } from './stores/authStore'
import { useWorkspaceStore } from './stores/workspaceStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminGeneral',
  setup(__props) {

console.log('AdminGeneral component initializing')

const router = useRouter()
const { checkAuth } = useAuthStore()
const { refreshWorkspaceEmoji } = useWorkspaceStore()
const loading = ref(true)
const saving = ref(false)
const selectedEmoji = ref('')
const showSuccess = ref(false)
const showError = ref(false)
const errorMessage = ref('')
const menuOpen = ref(false)

// Create emoji index
const emojiIndex = new EmojiIndex(data)

const loadWorkspaceData = async () => {
  try {
    // First check if user is admin using auth store
    const authData = await checkAuth()
    if (!authData.isAdmin) {
      router.push('/dashboard')
      return
    }

    // Load workspace settings from our server
    const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/admin/workspace/settings`, {
      credentials: 'include'
    })
    
    if (response.ok) {
      const data = await response.json()
      selectedEmoji.value = data.emoji_shortcode || ':pray:'
    } else {
      // Use default if no settings found
      selectedEmoji.value = ':pray:'
    }
  } catch (error) {
    console.error('Error loading workspace data:', error)
    errorMessage.value = 'Failed to load workspace data'
    showError.value = true
  } finally {
    loading.value = false
  }
}

const selectEmoji = (emoji) => {
  selectedEmoji.value = `:${emoji.id}:`
  menuOpen.value = false
}

const getSelectedEmojiSymbol = computed(() => {
  const shortcode = selectedEmoji.value.replace(/:/g, '')
  const emoji = emojiIndex.findEmoji(shortcode)
  return emoji ? emoji.native : '🙏'
})

const saveEmoji = async () => {
  saving.value = true
  showSuccess.value = false
  showError.value = false
  
  try {
    // Check if user is still admin before saving using auth store
    const authData = await checkAuth()
    if (!authData.isAdmin) {
      throw new Error('Unauthorized: Admin access required')
    }

    // Save settings to our server
    const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/admin/workspace/settings`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        emoji_shortcode: selectedEmoji.value
      })
    })

    if (!response.ok) {
      throw new Error('Failed to save settings')
    }

    // Refresh the workspace store cache to update emoji across all components
    console.log('Refreshing workspace emoji cache...')
    await refreshWorkspaceEmoji()
    console.log('Workspace emoji cache refreshed')

    showSuccess.value = true
  } catch (error) {
    console.error('Error saving emoji settings:', error)
    errorMessage.value = error.message === 'Unauthorized: Admin access required' 
      ? 'You do not have permission to save settings' 
      : 'Failed to save settings'
    showError.value = true
  } finally {
    saving.value = false
  }
}

onMounted(async () => {
  console.log('AdminGeneral component mounted')
  await loadWorkspaceData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(AdminLayout, { showStatsSidebar: false }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        fluid: "",
        class: "pa-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            elevation: "3",
            class: "rounded-lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex align-center pa-6 bg-gradient-primary" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-cog",
                    class: "mr-3",
                    size: "32",
                    color: "white"
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-h5 font-weight-bold text-white" }, "General Settings", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "pa-6" }, {
                default: _withCtx(() => [
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "primary",
                          size: "64",
                          width: "6"
                        }),
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ml-4 text-h6 text-medium-emphasis" }, "Loading settings...", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (showSuccess.value)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: "success",
                              class: "mb-6",
                              closable: "",
                              variant: "tonal",
                              border: "start",
                              "border-color": "success"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-check-circle",
                                  color: "success"
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-weight-medium" }, "Settings saved successfully!", -1)),
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    icon: "mdi-close",
                                    variant: "text",
                                    size: "small",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showSuccess.value = false))
                                  })
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (showError.value)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 1,
                              type: "error",
                              class: "mb-6",
                              closable: "",
                              variant: "tonal",
                              border: "start",
                              "border-color": "error"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-alert-circle",
                                  color: "error"
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("span", _hoisted_5, _toDisplayString(errorMessage.value), 1),
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    icon: "mdi-close",
                                    variant: "text",
                                    size: "small",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false))
                                  })
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_form, {
                          onSubmit: _withModifiers(saveEmoji, ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_container, {
                              fluid: "",
                              class: "pa-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                          _createVNode(_component_v_icon, {
                                            icon: "mdi-emoticon",
                                            color: "primary",
                                            class: "mr-3",
                                            size: "24"
                                          }),
                                          _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-h6 font-weight-bold mb-0" }, "Kudos Emoji Configuration", -1))
                                        ]),
                                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-body-2 text-medium-emphasis mb-6" }, " Choose the emoji that will be used when users give kudos to each other. This emoji will appear in the leaderboard and throughout the application. ", -1)),
                                        _createElementVNode("div", _hoisted_7, [
                                          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-subtitle-1 font-weight-medium mb-3 d-block" }, " Selected Emoji ", -1)),
                                          _createVNode(_component_v_menu, {
                                            modelValue: menuOpen.value,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((menuOpen).value = $event)),
                                            "close-on-content-click": false,
                                            location: "bottom"
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_btn, _mergeProps({ variant: "outlined" }, props, {
                                                class: "emoji-selector",
                                                size: "large",
                                                color: "primary"
                                              }), {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", _hoisted_8, _toDisplayString(getSelectedEmojiSymbol.value), 1),
                                                  _createElementVNode("div", _hoisted_9, [
                                                    _createElementVNode("span", _hoisted_10, _toDisplayString(selectedEmoji.value), 1),
                                                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-caption text-medium-emphasis" }, "Click to change", -1))
                                                  ]),
                                                  _createVNode(_component_v_icon, {
                                                    icon: "mdi-chevron-down",
                                                    class: "ml-4"
                                                  })
                                                ]),
                                                _: 2
                                              }, 1040)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card, {
                                                "min-width": "350",
                                                class: "emoji-picker-card"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_card_title, { class: "pa-4 bg-light-blue-lighten-5" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, {
                                                        icon: "mdi-emoticon",
                                                        class: "mr-2",
                                                        color: "primary"
                                                      }),
                                                      _cache[8] || (_cache[8] = _createTextVNode(" Pick an Emoji ", -1))
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_card_text, { class: "pa-0" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(Picker), {
                                                        data: _unref(emojiIndex),
                                                        onSelect: selectEmoji,
                                                        native: true,
                                                        title: "Pick an emoji...",
                                                        emoji: "point_up",
                                                        "show-preview": false
                                                      }, null, 8, ["data"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                          _createVNode(_component_v_btn, {
                                            color: "primary",
                                            variant: "elevated",
                                            type: "submit",
                                            loading: saving.value,
                                            disabled: saving.value,
                                            size: "large",
                                            "prepend-icon": "mdi-content-save",
                                            class: "px-6"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(saving.value ? 'Saving...' : 'Save Changes'), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["loading", "disabled"])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})